import orderBy from 'lodash/orderBy'

const goodsList = [
  { label: 'Explosive', apiParam: 0, value: 'explosive' },
  { label: 'Gas', apiParam: 1, value: 'gas' },
  { label: 'Organic', apiParam: 4, value: 'organic' },
  { label: 'Poison', apiParam: 5, value: 'poison' },
  { label: 'Flammable', apiParam: 2, value: 'flammable' },
  { label: 'Combustible', apiParam: 3, value: 'combustible' },
  { label: 'Radioactive', apiParam: 6, value: 'radioActive' },
  { label: 'Corrosive', apiParam: 7, value: 'corrosive' },
  { label: 'Toxic Inhalant', apiParam: 8, value: 'poisonousInhalation' },
  { label: 'Water Pollutant', apiParam: 9, value: 'harmfulToWater' },
  { label: 'Other', apiParam: 10, value: 'other' }
]

export function getGoodSort(list) {
  let arr = list.map(item => {
    let info = goodsList.find(i => i.value === item)
    return info
  })
  arr = orderBy(arr, ['apiParam', 'age'])
  return arr.map(item => item.value)
}

export default goodsList